export var isMaxNestingLevelFunc = function isMaxNestingLevelFunc(level) {
  return level >= 6;
};